export default __webpack_public_path__ + "static/B0204-c8afeeed13f657a0c03f8a7eb11d48da.png";